var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rotoverlay"},[_vm._v("\n  I haven't been given anything to put here..."),_c('br'),_vm._v("\n  Ampharos is objectively the best pokemon if you disagree you're wrong"),_c('br'),_vm._v(" "),_c('div',[_c('ul',[_c('li',[_vm._v("（´・ω・｀）")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20b18140","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Overlay.vue
// module id = null
// module chunks = 